import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import MarkdownLink from '../markdown-link/markdown-link';
import * as S from './styles';

/* eslint-disable-next-line */
type SectionDescriptionProps = {
  description: string;
  isCentered?: boolean;
  shouldLinksRedirectToNewTab?: boolean;
};

export function SectionDescription(props: SectionDescriptionProps) {
  const {
    description,
    isCentered = false,
    shouldLinksRedirectToNewTab = false
  } = props;

  const newLinkProp = shouldLinksRedirectToNewTab
    ? {
        components: { a: MarkdownLink }
      }
    : '';

  return (
    <S.Container
      className={`${isCentered ? 'text-center' : 'text-left'} font-light mt-2`}
    >
      <ReactMarkdown rehypePlugins={[rehypeRaw]} {...newLinkProp}>
        {description}
      </ReactMarkdown>
    </S.Container>
  );
}

export default SectionDescription;
